export default __webpack_public_path__ + "static/media/location.451bd18f.png";